import { useEffect, useState } from 'react';

export interface TocItem {
  id: string;
  text: string;
}

export default function ArticleToc({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState<string>(items[0]?.id ?? '');

  useEffect(() => {
    if (items.length === 0) return;
    const onScroll = () => {
      let current = items[0].id;
      items.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = item.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [items]);

  if (items.length === 0) return null;

  return (
    <nav aria-label="文章目录">
      <h2 className="font-heading text-sm font-semibold text-foreground-950 mb-4 flex items-center gap-2">
        <span className="w-4 h-4 flex items-center justify-center text-primary-500">
          <i className="ri-list-check" />
        </span>
        本文目录
      </h2>
      <ul className="space-y-1 border-l border-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block pl-4 py-2 text-sm leading-6 border-l-2 -ml-px transition-colors ${
                active === item.id
                  ? 'border-primary-500 text-primary-600 font-medium'
                  : 'border-transparent text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}